/**
 * Saved Filters Getters
 */

export default {
  /**
   * Get all saved filters
   */
  allFilters: (state) => state.filters,

  /**
   * Get filters for a specific view
   * @param {String} viewName - Name of the view (e.g., 'time', 'pacing', 'discrepancy')
   */
  filtersByView: (state) => (viewName) => state.filters.filter((f) => f.view === viewName),

  /**
   * Get a specific filter by ID
   */
  filterById: (state) => (id) => state.filters.find((f) => f.id === id),

  /**
   * Get currently active filter
   */
  activeFilter: (state) => state.filters.find((f) => f.id === state.activeFilterId),

  /**
   * Check if filters are loading
   */
  isLoading: (state) => state.loading,

  /**
   * Get error state
   */
  error: (state) => state.error,
}
